import React, { lazy, Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from 'components/shared-components/Loading';
import { APP_PREFIX_PATH } from 'configs/AppConfig'
import PortalAdmin from "./apps/servicio-autenticacion";
import PortalContratos from "./apps/servicio-contratos"
import PortalLiquidaciones from "./apps/servicio-liquidacion-digital"
import PortalReportes from "./apps/servicio-reportes"
import PortalPresupuesto from "./apps/servicio-gestion-presupuesto"
import PortalBill from "./apps/servicio-gestion-bill"
import PortalPlayero from "./apps/servicio-gestion-playero";
import withModulos from './hocModulos/withModulos';

//Restrincciones
const PrincipalRestricted = withModulos(true, ['PORTAL ADMIN'], PortalAdmin);
const contratosRestricted = withModulos(true, ['CONTRATOS'], PortalContratos);
const LiquidacionesRestricted = withModulos(true, ['LIQUIDACIONES'], PortalLiquidaciones);
const ReportesRestricted = withModulos(true, ['REPORTES'], PortalReportes)
const PresupuestoRestricted = withModulos(true, ['PROCESAR PRESUPUESTO'], PortalPresupuesto)
const billRestricted = withModulos(true, ['VISUALIZAR FACTURAS'], PortalBill)
const beachRestricted = withModulos(true, ['PLAYERO'], PortalPlayero)
const InformesDiariosRestricted = withModulos(
  true,
  ['INFORMES DIARIOS'],
  lazy(() => import(`../informesDiarios/Index`))
)
const ActividadesRestricted = withModulos(
  true,
  ['INFORMES DIARIOS'],
  lazy(() => import(`../actividades/Index`))
)
const InformesAccessRestricted = withModulos(
  true,
  ['INFORMES DIARIOS'],
  lazy(() => import(`../informesDiarios/AccessControl`))
)
const CierresMedicionRestricted = withModulos(
  true,
  ['INFORMES DIARIOS'],
  lazy(() => import(`../cierresMedicion/Index`))
)
const CierresMedicionDetalleRestricted = withModulos(
  true,
  ['INFORMES DIARIOS'],
  lazy(() => import(`../cierresMedicion/Detalle`))
)
const ConsultaSifenRestricted = withModulos(
  true,
  ['CONSULTA SIFEN'],
  lazy(() => import(`../consultaSifen/Index`))
)
const ConsultaRucRestricted = withModulos(
  true,
  ['CONSULTA SIFEN', 'CONSULTA RUC'],
  lazy(() => import(`../consultaRuc/Index`))
)
const LicensesRestricted = withModulos(
  true,
  ['GESTION DE LICENCIAS'],
  lazy(() => import(`../licenses/Index`))
)
const LicenseDetailRestricted = withModulos(
  true,
  ['GESTION DE LICENCIAS'],
  lazy(() => import(`../licenses/Detail`))
)

export const AppViews = () => {
  return (
    <Suspense fallback={<Loading cover="content" />}>
      <Switch>
        <Route path={`${APP_PREFIX_PATH}/dashboards`} component={lazy(() => import(`./dashboards`))} />
        <Route path={`${APP_PREFIX_PATH}/apps`} component={PrincipalRestricted} />
        <Route path={`${APP_PREFIX_PATH}/apps1`} component={lazy(() => import(`./apps/servicio-gestion-vacaciones`))} />
        <Route path={`${APP_PREFIX_PATH}/apps2`} component={contratosRestricted} />
        <Route path={`${APP_PREFIX_PATH}/apps3`} component={LiquidacionesRestricted} />
        <Route path={`${APP_PREFIX_PATH}/apps4`} component={ReportesRestricted} />
        <Route path={`${APP_PREFIX_PATH}/apps5`} component={PresupuestoRestricted} />
        <Route path={`${APP_PREFIX_PATH}/apps6`} component={billRestricted} />
        <Route path={`${APP_PREFIX_PATH}/apps7`} component={beachRestricted} />
        <Route path={`${APP_PREFIX_PATH}/cierres-medicion/:id`} component={CierresMedicionDetalleRestricted} />
        <Route path={`${APP_PREFIX_PATH}/cierres-medicion`} component={CierresMedicionRestricted} />
        <Route path={`${APP_PREFIX_PATH}/informes-diarios/accesos`} component={InformesAccessRestricted} />
        <Route path={`${APP_PREFIX_PATH}/informes-diarios`} component={InformesDiariosRestricted} />
        <Route path={`${APP_PREFIX_PATH}/actividades`} component={ActividadesRestricted} />
        <Route path={`${APP_PREFIX_PATH}/consulta-sifen`} component={ConsultaSifenRestricted} />
        <Route path={`${APP_PREFIX_PATH}/consulta-ruc`} component={ConsultaRucRestricted} />
        <Route path={`${APP_PREFIX_PATH}/licencias/:id`} component={LicenseDetailRestricted} />
        <Route path={`${APP_PREFIX_PATH}/licencias`} component={LicensesRestricted} />
        <Route path={`${APP_PREFIX_PATH}/profile`} component={lazy(() => import(`./apps/servicio-autenticacion/profile`))} />
        <Redirect from={`${APP_PREFIX_PATH}`} to={`${APP_PREFIX_PATH}/dashboards/inicio`} />
      </Switch>
    </Suspense>
  )
}


export default React.memo(AppViews);
